import { getCreatorApiUrl } from '@client/components/api-urls';
import auth from '@client/components/auth';
import axios from 'axios';
import { httpClient } from './api';

export const getStripeConnectUrl = async (influencerId: number) => {
  const token = auth.getToken();
  const url = getCreatorApiUrl(
    `/admin-influencers/${influencerId}/create-stripe-account`,
  );

  const res = await axios.post(
    url,
    {},
    {
      headers: {
        Authorization: token,
      },
    },
  );

  return res.data.connectLink;
};

export const verifyStripeMode = async (influencerId: number) => {
  const token = auth.getToken();
  const url = getCreatorApiUrl(
    `/admin-influencers/${influencerId}/verify-stripe-account`,
  );
  const res = await axios.post(
    url,
    {},
    {
      headers: {
        Authorization: token,
      },
    },
  );

  return res.data.isLive;
};

export const getStripeLoginUrl = async (influencerId: number) => {
  const res = await httpClient.get(
    getCreatorApiUrl(`/admin-influencers/${influencerId}/get-stripe-login`),
  );

  return res.data;
};

export const removeStripe = async (influencerId: number) => {
  return httpClient.post(
    getCreatorApiUrl(`/admin-influencers/${influencerId}/remove-stripe`),
    {},
  );
};
